import React, { useEffect, useMemo, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import "./CommercialsDetails.css";

import heroBg1 from "../../assets/harmonone.jpeg";
import heroBg2 from "../../assets/harmontwo.jpeg";
import heroBg3 from "../../assets/harmonthree.jpeg";
import heroBg4 from "../../assets/harmonfour.jpeg";

/* ---------------- Config ---------------- */
const FORM_ENDPOINT = "https://formspree.io/f/xwprpobw";
const RECAPTCHA_SITE_KEY =
  process.env.REACT_APP_RECAPTCHA_SITE_KEY ||
  "6Ldbb9QrAAAAAPRQP_QAThmTFAHRnSn5R3jJOHWC";

/* ---------------- Icons ---------------- */
const Icon = ({ name }) => {
  const icons = {
    arrowLeft: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M19 12H5M12 19l-7-7 7-7" />
      </svg>
    ),
    arrowRight: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M5 12h14M12 5l7 7-7 7" />
      </svg>
    ),
    mapPin: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M21 10c0 6-9 12-9 12S3 16 3 10a9 9 0 1 1 18 0z" />
        <circle cx="12" cy="10" r="3" />
      </svg>
    ),
    image: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <circle cx="8.5" cy="8.5" r="1.5" />
        <path d="M21 15l-5-5L5 21" />
      </svg>
    ),
    check: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
        <path d="M20 6L9 17l-5-5" />
      </svg>
    ),
    close: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M18 6L6 18M6 6l12 12" />
      </svg>
    ),
    send: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M22 2L11 13" />
        <path d="M22 2l-7 20-4-9-9-4 20-7z" />
      </svg>
    ),
    phone: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
      </svg>
    ),
    mail: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
        <polyline points="22,6 12,13 2,6" />
      </svg>
    ),
    user: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    ),
    tag: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L3 13.99V3h10.99l7.17 7.17a2 2 0 0 1 0 2.83z" />
        <circle cx="7.5" cy="7.5" r="1.5" />
      </svg>
    ),
    building: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <path d="M7 7h.01M11 7h.01M15 7h.01M7 11h.01M11 11h.01M15 11h.01M7 15h10" />
      </svg>
    ),
    car: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M3 13l2-5a3 3 0 0 1 3-2h6a3 3 0 0 1 3 2l2 5" />
        <path d="M5 13h14v6H5z" />
        <circle cx="7.5" cy="19" r="1" />
        <circle cx="16.5" cy="19" r="1" />
      </svg>
    ),
    flame: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M8 14a4 4 0 1 0 8 0c0-3-3-5-3-8-2 1-5 3-5 8z" />
      </svg>
    ),
    map: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M9 18l6 3 6-3V3l-6 3-6-3-6 3v15z" />
        <path d="M9 3v15M15 6v15" />
      </svg>
    ),
  };
  return icons[name] || null;
};

/* ---------------- Simple Lightbox ---------------- */
function Lightbox({ images = [], index = 0, onClose, onPrev, onNext }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
      if (e.key === "ArrowLeft") onPrev?.();
      if (e.key === "ArrowRight") onNext?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose, onPrev, onNext]);

  if (!images.length) return null;
  const src = images[index] || images[0];

  return (
    <div className="commercials-lightbox" onClick={onClose} role="dialog" aria-modal="true">
      <div className="commercials-lightbox-inner" onClick={(e) => e.stopPropagation()}>
        <button className="commercials-lightbox-close" onClick={onClose} aria-label="Close">
          <Icon name="close" />
        </button>
        <button className="commercials-lightbox-nav prev" onClick={onPrev} aria-label="Previous">
          <Icon name="arrowLeft" />
        </button>
        <img className="commercials-lightbox-img" src={src} alt="Large preview" />
        <button className="commercials-lightbox-nav next" onClick={onNext} aria-label="Next">
          <Icon name="arrowRight" />
        </button>
        <div className="commercials-lightbox-counter">
          {index + 1} / {images.length}
        </div>
      </div>
    </div>
  );
}

/* ---------------- Main Page ---------------- */
export default function CommercialsDetails() {
  const sampleImages = [heroBg1, heroBg2, heroBg3, heroBg4];

  const property = {
    title: "Commercial Spaces",
    Status: "Upcoming",
    propertyType: "Commercial",
    parking: "One parking space included in lease",
    description: [
      "The Harmon sits at the center of downtown Tacoma, surrounded by the city's busiest streets, restaurants, and cultural spots. This landmark property combines historic character with modern opportunity, giving your business instant visibility in a high-traffic location. Leasing here places you directly in front of professionals, students, and visitors every day. It's a chance to set up shop where Tacoma gathers and to be part of the city's ongoing growth and energy."
    ],
    features: [
      "Prime gateway location on Pacific Avenue, Tacoma's busiest street and the main entry into downtown",
      "Unmatched visibility with heavy daily vehicle and foot traffic from professionals, students, and visitors",
      "Onsite secure garage providing reliable parking for tenants and staff",
      "Direct light rail access connecting the property to the whole area",
      "Historic character with flexible layouts that adapt to modern retail, dining, and office needs",
      "Central downtown hub placing your business steps away from Tacoma's cultural, dining, and entertainment core"
    ],
    contact: {
      phone: "253-627-2663",
      email: "info@harmon.property",
      manager: "Suzanne Steliga",
    },
  };

  const [activeIdx, setActiveIdx] = useState(0);
  const [showApply, setShowApply] = useState(false);
  const [lbOpen, setLbOpen] = useState(false);
  const [lbIndex, setLbIndex] = useState(0);

  // Apply form status
  const [applySuccess, setApplySuccess] = useState(false);
  const [applyError, setApplyError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const successTimerRef = useRef(null);

  // reCAPTCHA
  const [captchaToken, setCaptchaToken] = useState(null);
  const recaptchaRef = useRef(null);

  const thumbsRef = useRef(null);

  const mainImage = useMemo(
    () => sampleImages[activeIdx] || sampleImages[0],
    [sampleImages, activeIdx]
  );

  useEffect(() => {
    const el = thumbsRef.current?.querySelector(`[data-index="${activeIdx}"]`);
    if (el) el.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
  }, [activeIdx]);

  useEffect(() => {
    return () => {
      if (successTimerRef.current) window.clearTimeout(successTimerRef.current);
    };
  }, []);

  const dash = (v) => (v === null || v === undefined || v === "" ? "—" : v);

  const handleApplySubmit = async (e) => {
    e.preventDefault();
    setApplyError(null);

    if (!captchaToken) {
      setApplyError("Please complete the reCAPTCHA.");
      return;
    }

    setIsSubmitting(true);
    try {
      const formEl = e.currentTarget;
      const formData = new FormData(formEl);

      // Include extra metadata if you want (helps in your inbox)
      formData.append("_subject", "Commercial Inquiry via Harmon Property");
      formData.append("property", property.title);
      // IMPORTANT for Formspree + reCAPTCHA v2:
      formData.append("g-recaptcha-response", captchaToken);

      const res = await fetch(FORM_ENDPOINT, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData,
      });

      if (!res.ok) {
        const data = await res.json().catch(() => null);
        throw new Error(data?.error || "Submission failed. Please try again.");
      }

      // Success UX
      formEl.reset();
      setShowApply(false);
      setApplySuccess(true);

      // Clear captcha & reset widget
      setCaptchaToken(null);
      recaptchaRef.current?.reset();

      if (successTimerRef.current) window.clearTimeout(successTimerRef.current);
      successTimerRef.current = window.setTimeout(() => setApplySuccess(false), 5000);
    } catch (err) {
      setApplyError(err.message || "Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="commercials-wrap">
      <div className="commercials-container">
        {/* Header */}
        <header className="commercials-header">
          <div className="commercials-header-left">
            <h1 className="commercials-title">{property.title}</h1>
            <div className="commercials-subtitle">Premium Downtown Tacoma Location</div>
          </div>
          <div className="commercials-status-badge">
            <span className="commercials-status-dot"></span>
            {property.Status}
          </div>
        </header>

        {/* Gallery */}
        <section className="commercials-gallery">
          <div
            className="commercials-mainimg"
            style={{ backgroundImage: `url(${mainImage})` }}
            role="img"
            aria-label="Property main image"
            onClick={() => {
              setLbIndex(activeIdx);
              setLbOpen(true);
            }}
          >
            {sampleImages.length > 1 && (
              <>
                <button
                  className="commercials-nav prev"
                  onClick={(e) => {
                    e.stopPropagation();
                    setActiveIdx((p) => (p - 1 + sampleImages.length) % sampleImages.length);
                  }}
                  aria-label="Previous image"
                >
                  <Icon name="arrowLeft" />
                </button>
                <button
                  className="commercials-nav next"
                  onClick={(e) => {
                    e.stopPropagation();
                    setActiveIdx((p) => (p + 1) % sampleImages.length);
                  }}
                  aria-label="Next image"
                >
                  <Icon name="arrowRight" />
                </button>
              </>
            )}
            {sampleImages.length > 1 && (
              <div className="commercials-gallery-counter">
                {activeIdx + 1} / {sampleImages.length}
              </div>
            )}
            <div className="commercials-image-overlay">
              <span className="commercials-zoom-hint">Click to enlarge</span>
            </div>
          </div>

          <div className="commercials-thumbs" ref={thumbsRef}>
            {sampleImages.length ? (
              sampleImages.map((src, i) => (
                <button
                  key={i}
                  data-index={i}
                  className={`commercials-thumb ${i === activeIdx ? "is-active" : ""}`}
                  onClick={() => setActiveIdx(i)}
                  aria-label={`Show image ${i + 1}`}
                  onDoubleClick={() => {
                    setLbIndex(i);
                    setLbOpen(true);
                  }}
                >
                  <img src={src} alt={`Thumbnail ${i + 1}`} loading="lazy" />
                  <div className="commercials-thumb-overlay"></div>
                </button>
              ))
            ) : (
              <div className="commercials-thumb-empty">
                <Icon name="image" /> No images
              </div>
            )}
          </div>
        </section>

        {/* Specs */}
        <section className="commercials-specs">
          <div className="commercials-specs-item">
            <div className="commercials-specs-icon"><Icon name="tag" /></div>
            <div className="commercials-specs-content">
              <div className="commercials-specs-label">Status</div>
              <div className="commercials-specs-value">{dash(property.Status)}</div>
            </div>
          </div>

          <div className="commercials-specs-item">
            <div className="commercials-specs-icon"><Icon name="building" /></div>
            <div className="commercials-specs-content">
              <div className="commercials-specs-label">Property Type</div>
              <div className="commercials-specs-value">{dash(property.propertyType)}</div>
            </div>
          </div>

          <div className="commercials-specs-item">
            <div className="commercials-specs-icon"><Icon name="car" /></div>
            <div className="commercials-specs-content">
              <div className="commercials-specs-label">Parking</div>
              <div className="commercials-specs-value">{dash(property.parking)}</div>
            </div>
          </div>
        </section>

        {/* Content */}
        <div className="commercials-content">
          <main className="commercials-main">
            <section className="commercials-card">
              <h2 className="commercials-h2">Property Description</h2>
              {property.description.map((p, i) => (
                <p key={i} className="commercials-text">{p}</p>
              ))}
            </section>

            <section className="commercials-card">
              <h2 className="commercials-h2">Features & Amenities</h2>
              <ul className="commercials-list commercials-list--stack">
                {property.features.map((f, i) => (
                  <li key={i} className="commercials-li">
                    <span className="commercials-li-ic" aria-hidden="true"><Icon name="check" /></span>
                    <span className="commercials-li-text">{f}</span>
                  </li>
                ))}
              </ul>
            </section>
          </main>

          {/* Sidebar */}
          <aside className="commercials-aside">
            <div className="commercials-aside-card commercials-sticky">
              <h3 className="commercials-aside-title">Interested in this Space?</h3>

              {/* Inline success notice */}
              {applySuccess ? (
                <div className="commercials-inlineNotice" role="status" aria-live="polite">
                  <div className="commercials-inlineNotice__icon"><Icon name="check" /></div>
                  <div className="commercials-inlineNotice__body">
                    <div className="commercials-inlineNotice__title">Message sent successfully</div>
                    <div className="commercials-inlineNotice__sub">We'll get back to you soon.</div>
                  </div>
                </div>
              ) : (
                <>
                  <p className="commercials-aside-text">
                    Contact us to schedule a viewing or get more information about this premium commercial space.
                  </p>
                  <button className="commercials-btn full" onClick={() => setShowApply(true)}>
                    <Icon name="send" /> Contact Agent
                  </button>
                </>
              )}

              <div className="commercials-contact-info">
                <h4>Contact Information</h4>
                <div className="commercials-contact-item">
                  <Icon name="phone" />
                  <span>{property.contact.phone}</span>
                </div>
                <div className="commercials-contact-item">
                  <Icon name="mail" />
                  <span>{property.contact.email}</span>
                </div>
                <div className="commercials-contact-item">
                  <Icon name="user" />
                  <span>{property.contact.manager}</span>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>

      {/* Apply Modal */}
      {showApply && (
        <div className="commercials-modal" role="dialog" aria-modal="true" onClick={() => setShowApply(false)}>
          <div className="commercials-dialog" onClick={(e) => e.stopPropagation()}>
            <button className="commercials-close" onClick={() => setShowApply(false)} aria-label="Close">
              <Icon name="close" />
            </button>
            <h3 className="commercials-dialog-title">Schedule a Viewing</h3>

            {/* Error message */}
            {applyError && (
              <div className="commercials-error" role="alert" aria-live="assertive">
                {applyError}
              </div>
            )}

            <form className="commercials-form" onSubmit={handleApplySubmit}>
              {/* Hidden context fields */}
              <input type="hidden" name="property" value={property.title} />
              <input type="hidden" name="_subject" value="Commercial Inquiry via Harmon Property" />

              <div className="commercials-field">
                <label>Full Name</label>
                <input name="name" placeholder="Your full name" required />
              </div>
              <div className="commercials-field">
                <label>Email Address</label>
                <input name="email" type="email" placeholder="you@example.com" required />
              </div>
              <div className="commercials-field">
                <label>Phone Number</label>
                <input name="phone" type="tel" placeholder="Your phone number" />
              </div>
              <div className="commercials-field">
                <label>Company Name</label>
                <input name="company" placeholder="Your company name" />
              </div>
              <div className="commercials-field">
                <label>Message</label>
                <textarea name="message" placeholder="Tell us about your business needs..." rows={5} />
              </div>

              {/* Google reCAPTCHA */}
              <div className="commercials-field">
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={RECAPTCHA_SITE_KEY}
                  onChange={setCaptchaToken}
                  onExpired={() => setCaptchaToken(null)}
                />
              </div>

              <button className="commercials-btn" type="submit" disabled={isSubmitting || !captchaToken}>
                <Icon name="send" /> {isSubmitting ? "Sending..." : "Send Inquiry"}
              </button>
              <button
                type="button"
                className="commercials-btn ghost"
                onClick={() => setShowApply(false)}
                disabled={isSubmitting}
              >
                Cancel
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Image Lightbox */}
      {lbOpen && (
        <Lightbox
          images={sampleImages}
          index={lbIndex}
          onClose={() => setLbOpen(false)}
          onPrev={() => setLbIndex((p) => (p - 1 + sampleImages.length) % sampleImages.length)}
          onNext={() => setLbIndex((p) => (p + 1) % sampleImages.length)}
        />
      )}
    </div>
  );
}